import React from "react";
import { Helmet } from "react-helmet-async";
import { ASSETS } from "@/lib/brand";

const SITE = "iammiguelsantana.com";
const DEFAULT_TITLE = "Miguel Santana · Founder of MPR Ventures";
const DEFAULT_DESC = "Miguel Santana — Dominican-American entrepreneur and founder of MPR Ventures. A multi-city American conglomerate operating across hospitality, brands, capital, culture, sports, and civic impact.";
const DEFAULT_OG = ASSETS.portrait1;
const BASE_URL = "https://iammiguelsantana.com";

export default function Seo({ title, description, image, path = "", type = "website", noIndex = false }) {
  const fullTitle = title ? `${title} · Miguel Santana` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const ogImage = image || DEFAULT_OG;
  const canonical = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="1200" />
      <meta property="og:url" content={canonical} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@iammiguelsantana" />
      <meta name="twitter:creator" content="@iammiguelsantana" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured data — Person */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Person",
        "name": "Miguel Santana",
        "url": BASE_URL,
        "image": DEFAULT_OG,
        "jobTitle": "Founder & Chief Executive",
        "worksFor": {
          "@type": "Organization",
          "name": "MPR Ventures",
        },
        "nationality": "American",
        "birthPlace": "Santo Domingo, Dominican Republic",
        "birthDate": "1987-10-01",
        "sameAs": [
          "https://instagram.com/iammiguelsantana",
          "https://x.com/iammiguelsantana",
          "https://tiktok.com/@iammiguelsantana",
          "https://youtube.com/@iammiguelsantana",
        ],
      })}</script>
    </Helmet>
  );
}
